import { SnackbarProvider } from 'notistack';

export function FSSnackbarProvider() {
  return (
    <SnackbarProvider
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    />
  );
}
